import { render, staticRenderFns } from "./OrderProductListItem.vue?vue&type=template&id=5cd3b595&"
import script from "./OrderProductListItem.vue?vue&type=script&lang=ts&"
export * from "./OrderProductListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports